import './ui/styles/index.scss';

import React from 'react';
import { Route, Routes } from 'react-router-dom';

import {
  ContactForm,
  FraudForm,
  PageLayoutComponent,
  ReactivationForm,
  SecurityForm,
  StandardForm,
  TechnicalForm,
} from './ui/components';
import { FooterComponent, HeaderComponent } from './ui/dsfr';
import { ErrorPage, LegacyPage, ResultPage, SupportPage } from './ui/pages';

export const ApplicationLayout = React.memo(() => (
  <React.Fragment>
    <div className="fr-mb-8w">
      <HeaderComponent />
      <main className="fr-container--fluid" role="main">
        <Routes>
          <Route element={<PageLayoutComponent />} path="/">
            <Route path="formulaire">
              <Route element={<ContactForm />} path="faq/contact" />
              <Route element={<FraudForm />} path="usurpation/:fraudSurveyOrigin" />
              <Route element={<SecurityForm />} path="faq/securite" />
              <Route element={<ReactivationForm />} path="reactivation/:errorCode" />
              <Route element={<StandardForm />} path="standard/:errorCode" />
              <Route element={<TechnicalForm />} path="technique/:errorCode" />
              <Route index element={<LegacyPage />} />
            </Route>
            <Route element={<ResultPage />} path="confirmation" />
            <Route element={<ErrorPage />} path="*" />
            <Route index element={<SupportPage />} />
          </Route>
        </Routes>
      </main>
    </div>
    <FooterComponent />
  </React.Fragment>
));

ApplicationLayout.displayName = 'ApplicationLayout';
